import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { TokenService } from 'src/app/services/token.service';

@Component({
    selector: 'app-token',
    templateUrl: './token.component.html',
    styleUrls: ['./token.component.css'],
    standalone: false
})
export class TokenComponent implements OnInit {
  total = 0;
  loading = true;
  search; //String que irá guardar o que o usuário quer pesquisar
  isVisibleCancelFiltro = false;
  pageSize = 10;
  pageIndex = 1;
  isVisibleDetalhe = false;
  
  tokens: any = [];

  constructor(
    private message: NzMessageService,
    private route: ActivatedRoute,
    private router: Router,
    private tokenService: TokenService,
  ) {

  }

  ngOnInit(): void {
  }

  enviarEmail(id: any){
    let idLoading = this.message.loading('Enviando email...').messageId;
    this.loading = true;
    this.tokenService.enviarEmail(id).subscribe((i: any) => {
      this.message.remove(idLoading);
      this.message.success('E-mail enviado com sucesso!');
      this.loading = false;
    });
  }
  excluir(id: any) {
    let idLoading = this.message.loading('Excluindo token...').messageId;
    this.loading = true;
    this.tokenService.excluir(id).subscribe((i: any) => {
      this.message.remove(idLoading);
      this.message.success('Exclusão realizada com sucesso!');
      this.loading = false;
      this.recarregarDados();
    });
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.tokenService.all(this.pageIndex, this.search).subscribe((m: any) => {
      this.pageIndex = params.pageIndex;
      this.tokens = m.data.tokens.data;
      this.total = m.data.tokens.total;
      this.pageSize = m.data.tokens.per_page;
      this.loading = false;
    });
  }

  recarregarDados(){
    this.tokenService.all(1, this.search).subscribe((m: any) => {
      this.pageIndex = 1;
      this.tokens = m.data.tokens.data;
      this.total = m.data.tokens.total;
      this.pageSize = m.data.tokens.per_page;
      this.loading = false;
    });
  }

  removerFiltro() {
    this.search = '';
    this.searchTokens();
    this.isVisibleCancelFiltro = false;
  }

  searchTokens() {
    if (this.search !== undefined) {
      this.isVisibleCancelFiltro = true;
      this.loading = true;    
      this.tokenService.all(this.pageIndex, this.search).subscribe((m: any) => {
        this.pageIndex = 1;
        this.tokens = m.data.tokens.data;
        this.total = m.data.tokens.total;
        this.pageSize = m.data.tokens.per_page;
        this.loading = false;
      });
    } else {
      this.message.warning("Digite a sua pesquisa para continuar.");
    }

  }

  closeModalDetalhe() {
    this.isVisibleDetalhe = false;
  }

}
